module.exports = __webpack_public_path__ + "integration-slimcd-logo.png?80b2d6176c7af8fe731ec12840104d36";